import { MentionCount } from './MentionCount';

type Props = {
  /** Muted detail (engine type, part description, reference title); cut to one line. */
  text: string | null | undefined;
  /** The entity's mention count, at the right end of the line. */
  mentions: number | undefined;
};

/** The last line of an entity card: its muted detail and its mention count; nothing when both are empty. */
export function FootLine({ text, mentions }: Props) {
  if (!text && !mentions) return null;
  return (
    <div className="flex items-center gap-2">
      {text && (
        <span className="min-w-0 truncate text-xs text-gray-500 dark:text-zinc-400" title={text}>
          {text}
        </span>
      )}
      <MentionCount count={mentions} />
    </div>
  );
}
